import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios, { AxiosRequestConfig } from "axios";
import { ProductTranslationFormValues, ProductTranslationUpdateResource } from "../types/productTranslation";

const baseKey = ["product-translations"];

export const productTranslationsService = {
	overviewKey: baseKey,
	overview: (config?: AxiosRequestConfig) =>
		axios.get<LaravelResponse<ProductTranslationUpdateResource>>(keyToUrl(baseKey), config),
	update: (productTranslations: ProductTranslationFormValues) =>
		axios.put<undefined>(keyToUrl(baseKey), productTranslations),
};
